'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _form = require('../form');

var _form2 = _interopRequireDefault(_form);

var _formInput = require('../../../molecules/forms/formInput');

var _formInput2 = _interopRequireDefault(_formInput);

var _formDropdown = require('../../../molecules/forms/formDropdown');

var _formDropdown2 = _interopRequireDefault(_formDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NameForm = function (_React$Component) {
    _inherits(NameForm, _React$Component);

    function NameForm() {
        _classCallCheck(this, NameForm);

        return _possibleConstructorReturn(this, (NameForm.__proto__ || Object.getPrototypeOf(NameForm)).apply(this, arguments));
    }

    _createClass(NameForm, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                _form2.default,
                {
                    validationInfo: this.props.validationInfo,
                    pageCode: this.props.pageCode,
                    sectionCode: this.props.sectionCode,
                    rowId: this.props.rowId,
                    saveTooltipInfo: this.props.saveTooltipInfo,
                    reduceTooltipInfoElement: this.props.reduceTooltipInfoElement,
                    tooltipInfo: this.props.tooltipInfo,
                    header: this.props.header,
                    label: this.props.label,
                    saveEvent: function saveEvent() {
                        return _this2.props.saveEvent();
                    },
                    cancelEvent: function cancelEvent() {
                        return _this2.props.cancelEvent();
                    },
                    allowEdit: this.props.allowEdit,
                    alwaysEditing: this.props.alwaysEditing,
                    validate: this.props.validate
                },
                _react2.default.createElement(_formDropdown2.default, {
                    fieldCode: 'gender',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'NameForm.gender' }),
                    value: this.props.person && { code: this.props.person.gender },
                    references: this.props.reference.references && this.props.reference.references['Gender'],
                    referencesEvent: function referencesEvent() {
                        return _this2.props.reference.doGetReferences('Gender');
                    },
                    changeEvent: function changeEvent(value) {
                        return _this2.props.changeEvent('person.gender', value.code);
                    },
                    allowEdit: this.props.allowEdit || this.props.alwaysEditing
                }),
                _react2.default.createElement(_formInput2.default, {
                    fieldCode: 'firstName',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'NameForm.firstName' }),
                    value: this.props.name && this.props.name.firstName,
                    changeEvent: function changeEvent(value) {
                        return _this2.props.changeEvent('firstName', value);
                    },
                    allowEdit: this.props.allowEdit || this.props.alwaysEditing
                }),
                _react2.default.createElement(_formInput2.default, {
                    fieldCode: 'middleName',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'NameForm.middleName' }),
                    value: this.props.name && this.props.name.middleName,
                    changeEvent: function changeEvent(value) {
                        return _this2.props.changeEvent('middleName', value);
                    },
                    allowEdit: this.props.allowEdit || this.props.alwaysEditing
                }),
                _react2.default.createElement(_formInput2.default, {
                    fieldCode: 'lastName',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'NameForm.lastName' }),
                    value: this.props.name && this.props.name.lastName,
                    changeEvent: function changeEvent(value) {
                        return _this2.props.changeEvent('lastName', value);
                    },
                    allowEdit: this.props.allowEdit || this.props.alwaysEditing
                })
            );
        }
    }]);

    return NameForm;
}(_react2.default.Component);

exports.default = NameForm;